import { errorResponse } from "../../constants/Constants";

export const getErrorMessage = (err: any) => {
    let errorRes: { status: number, message: string } = errorResponse;
    if (err.response! && err.response!.data!) {
        errorRes = {
            status: err.response.data.errorCode!,
            message: err.response.data.errorMessage!
        }
    }

    if (errorRes.status === undefined) {
        errorRes = {
            status: err.response.data.status!,
            message: err.response.data.message!
        }
    }
    return errorRes;
}